/**
 * Permission
 */
export default {
    pm: {
        Add: '添加',
        Edit: '编辑',
        Delete: '删除',
        Export: '导出',

        Users: '用户管理',
        Users_Users: '用户列表',
        Users_Users_Trust: '信任度',
        Users_Users_Export: '导出',

        Dashboard: '数据看板',
        Users_Overview: '用户概览',
        Dashboard_Features_Overview: '功能概览',
        Dashboard_Features_Overview_Export: '导出',

        'Financial-Management': '财务管理',
        'Financial-Management_Capital-Operation-Records': '资金操作记录',
        'Financial-Management_Capital-Operation-Records_Create': '创建',

        'System-Management': '系统管理',
        'System-Management_Accounts': '账号管理',
        'System-Management_Accounts_Create': '创建',
        'System-Management_Accounts_Update': '更新',
        'System-Management_Accounts_Delete': '删除',
        'System-Management_Roles': '角色管理',
        'System-Management_Roles_Create': '创建',
        'System-Management_Roles_Update': '更新',
        'System-Management_Roles_Delete': '删除',
        'System-Management_Configs': '配置管理',
        'System-Management_Configs_Create': '创建',
        'System-Management_Configs_Update': '更新',
        'System-Management_Configs_Delete': '删除',
        'System-Management_System-Logs': '系统日志',
        'System-Management_Downloads': '下载管理',
        'System-Management_Downloads_All-Data': '所有数据',
        'System-Management_Downloads_Personal-Data': '个人数据',

        'Client-Config': '客户端配置',
        'Client-Config_App-Version': 'App 版本配置',
        'Client-Config_App-Version_Create': '创建',
        'Client-Config_App-Version_Update': '更新',
        'Client-Config_Content-Filter': '版本内容过滤',
        'Client-Config_Content-Filter_Create': '添加',
        'Client-Config_Content-Filter_Update': '更新',
        'Client-Config_Content-Filter_Delete': '移除',

        Dramas: '短剧',
        Dramas_Dramas: '短剧管理',
        Dramas_Dramas_Review: '审核',
        Dramas_Dramas_Badge: '徽章',
        Dramas_Dramas_Export: '导出',
        Dramas_Dramas_Offline: '下架',
        'Dramas_Dramas_Heat-Coefficient': '热度系数',
        Dramas_Comments: '评论管理',
        Dramas_Comments_Delete: '删除',
        'Dramas_UGC-Reports': '用户举报',
        Dramas_Banner: '客户端 Banner',
        Dramas_Banner_Update: '更新',
        'Dramas_Mining-Weekly-Rewards': '挖矿结算',
        'Dramas_Mining-Weekly-Rewards_Review': '审核',
        'Dramas_Mining-Weekly-Rewards_Export': '导出',
        'Dramas_Activity-1011': '1011 活动',
        'Dramas_Activity-1011_Share-Review': '分享审核',
        'Dramas_Activity-1011_Share-Review_Review': '审核',
        'Dramas_Activity-1011_User-Stories': '故事收集',
        'Dramas_Activity-1011_Task-Config': '任务配置',
        'Dramas_Activity-1011_Task-Config_Update': '更新',
    },
};
